import jsPDF from "jspdf";
import { deviceService } from "../services/deviceService";
import { CONFIG } from "../config";

export const pdfUtils = {
  downloadDeviceBrandPDF: async (deviceID, brandName) => {
    try {
      //take the device total, claimed, unclaimed, active in the last 30 days and inactive in the last 30 days
      //and put them in a pdf

      //get the data
      let devices = await deviceService.getDevicesByBrand(deviceID);

      //format the data

      //get the total number of devices
      let totalDevices = devices.length;
      let claimedDevices = 0;
      let unclaimedDevices = 0;
      let activeDevices = 0;
      let inactiveDevices = 0;

      //get the number of claimed devices
      devices.forEach((device) => {
        if (device.claimed) {
          claimedDevices++;
        } else {
          unclaimedDevices++;
        }
      });

      //get the number of active devices in the last 30 days
      devices.forEach((device) => {
        //get the last seen date
        let lastSeen = new Date(device.last_seen);
        let today = new Date();
        let timeDiff = today.getTime() - lastSeen.getTime();
        let daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

        if (daysDiff <= 30) {
          activeDevices++;
        } else {
          inactiveDevices++;
        }
      });

      //create the pdf
      const doc = new jsPDF();

      //add the title
      doc.setFontSize(20);
      doc.text(`${brandName} Device Summary`, 20, 20);

      //add the config.company name
      doc.setFontSize(12);
      doc.text(`Company: ${CONFIG.company}`, 20, 40);

      //add the total number of devices
      doc.text(`Total Devices: ${totalDevices}`, 20, 60);

      //add the number of claimed devices
      doc.text(`Claimed Devices: ${claimedDevices}`, 20, 80);

      //add the number of unclaimed devices
      doc.text(`Unclaimed Devices: ${unclaimedDevices}`, 20, 100);

      //add the number of active devices in the last 30 days
      doc.text(`Active Devices (last 30 days): ${activeDevices}`, 20, 120);

      //add the number of inactive devices in the last 30 days
      doc.text(`Inactive Devices (last 30 days): ${inactiveDevices}`, 20, 140);

      //save the pdf
      doc.save(`${brandName}_device_summary.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
      throw error;
    }
  },
};
